import React from "react";
import CardPatientListV4 from "./common/CardPatientListV4";
import { PatientListV4SequenceState } from "./MainHISV4Interface";

/** แถว Encounter ที่ CardPatientListV4 ส่งมา (ข้อมูลสมมติในขั้น design) */
export type EncounterRecord = Record<string, unknown>;

export type EncounterViewContext = {
  selectedEncounter: EncounterRecord | null;
  onSelectEncounter: (item: unknown) => void;
  onActionEvent: (action: string, item: unknown) => void;
  onBackToQueue: () => void;
  /** เรียก sequence เช่น { message: "RunSequence", params: {...} } */
  onEvent?: (event: any) => void;
  setProp?: (key: string, value: any) => void;
  /** state จาก sequence PatientListV4 */
  PatientListV4Sequence?: PatientListV4SequenceState;
  searchedItemListWithKey?: Record<string, any>;
  divisionOptions?: any[];
  division?: number | string;
};

export interface ViewEncounterV4Props {
  /** list = Patient Queue, panel = Patient Panel + เมนู, record = หน้าย่อยใน Encounter */
  listView?: (context: EncounterViewContext) => React.ReactNode;
  panelView?: (context: EncounterViewContext) => React.ReactNode;
  recordView?: (context: EncounterViewContext) => React.ReactNode;
  selectedEncounter?: EncounterRecord | null;
  onSelectEncounter?: (encounter: unknown) => void;
  onActionEvent?: (action: string, encounter: unknown) => void;
  onBackToQueue?: () => void;
  onEvent?: (event: any) => void;
  setProp?: (key: string, value: any) => void;
  PatientListV4Sequence?: PatientListV4SequenceState;
  searchedItemListWithKey?: Record<string, any>;
  divisionOptions?: any[];
  division?: number | string;
}

export function isEncounterRecord(value: unknown): value is EncounterRecord {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export const ViewEncounterV4: React.FC<ViewEncounterV4Props> = ({
  listView,
  panelView,
  recordView,
  selectedEncounter,
  onSelectEncounter,
  onActionEvent,
  onBackToQueue,
  onEvent,
  setProp,
  PatientListV4Sequence,
  searchedItemListWithKey,
  divisionOptions,
  division,
}) => {
  const patient = isEncounterRecord(selectedEncounter) ? selectedEncounter : null;
  const context: EncounterViewContext = {
    selectedEncounter: patient,
    onSelectEncounter: onSelectEncounter ?? (() => undefined),
    onActionEvent: onActionEvent ?? (() => undefined),
    onBackToQueue: onBackToQueue ?? (() => undefined),
    onEvent,
    setProp,
    PatientListV4Sequence,
    searchedItemListWithKey,
    divisionOptions,
    division,
  };

  let content: React.ReactNode;
  if (patient !== null && panelView !== undefined) {
    content = panelView(context);
  } else if (patient !== null && recordView !== undefined) {
    content = recordView(context);
  } else if (listView !== undefined) {
    content = listView(context);
  } else {
    content = (
      <CardPatientListV4
        onSelectEncounter={context.onSelectEncounter}
        onActionEvent={context.onActionEvent}
        onEvent={onEvent}
        PatientListV4Sequence={PatientListV4Sequence}
        searchedItemListWithKey={searchedItemListWithKey}
        divisionOptions={divisionOptions}
        division={division}
      />
    );
  }

  return (
    <div
      className={`hisv4-view-encounter${patient !== null ? " hisv4-view-encounter--patient" : ""}`}
      style={{ width: "100%", height: "100%" }}
    >
      {content}
    </div>
  );
};

export default ViewEncounterV4;
